import { ParagraphText, SkeletonText } from '@leagueplatform/genesis-core';
import { useBenefitDetailInformation } from 'hooks/use-get-wallet-details/use-get-wallet-details.hook';
import { useFeatureFlags } from 'hooks/use-feature-flags/use-feature-flags.hook';
import { FEATURE_FLAGS } from 'common/firebase';

export function IDCardDisclaimer() {
  const { disclaimer, isLoading } = useBenefitDetailInformation();
  // ----> TODO SCAN-4117: Remove this code and Firebase flag after release
  const { featureFlags } = useFeatureFlags([
    FEATURE_FLAGS.MEDICAL_BENEFIT_DISCLAIMER,
  ]);
  const { release_medical_benefit_disclaimer: showDisclaimer } = featureFlags;
  if (!showDisclaimer) return null;
  // <----

  if (isLoading) return <SkeletonText lines={2} />;

  if (!disclaimer) return null;

  return <ParagraphText size="sm">{disclaimer}</ParagraphText>;
}
